module.exports = __webpack_public_path__ + "img/kbank.45a698c6.png";